<template>
    <canvas
        ref="canvas"
        :style="{
            userSelect: 'none',
        }"
        class=""
    />
</template>
<script>
import {
    ref, onMounted, onUnmounted,
    watch, nextTick, reactive,
    computed,
} from 'vue';
import { useResize } from '../../assets/js/vue/utlis/useResize';
import anime from 'animejs';
import { useResizeObserver } from '../../assets/js/vue/utlis/useResizeObserver';
import { useStore } from '../../store';

export default {
    name: 'PrivateRuler',
    props: {
        /**
         * @type {string[]}
         */
        products: {
            type: Array,
            default: () => [],
        },
        value: Number,
    },
    setup(props, { emit }) {
        const store = useStore();
        const isMobile = computed(() => store.state.app.isMobile);
        const innerWidth = computed(() => store.state.app.windowWidth);
        const canvas = ref(null);
        const width = 488;
        const height = 92;
        const width_mob = 328;
        const height_mob = 86;
        let ctx = undefined;
        const baseUnitWidth = 1;
        let unitWidth = baseUnitWidth;
        const baseSubInUnits = 8;
        const baseSubInUnits_mob = 5;
        let subInUnits = isMobile.value ? baseSubInUnits_mob : baseSubInUnits;
        const baseUnitSpace = 15;
        let unitSpace = baseUnitSpace;
        let offset = 0;
        let pointerStartValue = 0;
        let pointerIsDown = false;
        const countUnits = props.products.length;
        const pointerValue = ref(1 - props.value / countUnits);
        let pointerValueOld = 0;
        let moveDelta = 0;
        let scale = 1;
        let userAction = false;
        const canvasRect = reactive({});

        useResizeObserver(canvas, (entries) => {
            const el = entries[0];
            if (!el) return;

            const { left, width } = el.target.getBoundingClientRect();
            canvasRect.left = left;
            canvasRect.width = width;
        });

        const calcScale = () => {
            if (isMobile.value) {
                scale = innerWidth.value / 360;
            } else if (innerWidth <= 1440) {
                scale = innerWidth.value / 1920;
            } else {
                scale = 1;
            }
        };

        const updateSize = () => {
            ctx.canvas.width = isMobile.value ? width_mob * scale : width * scale;
            ctx.canvas.height = isMobile.value ? height_mob * scale : height * scale;
            unitSpace = baseUnitSpace * scale;
            unitWidth = baseUnitWidth * scale;
            subInUnits = isMobile.value ? baseSubInUnits_mob : baseSubInUnits;
        };

        const drawSubline = () => {
            const y = canvas.value.height - 1;
            ctx.strokeStyle = 'white';
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.setLineDash([4, 4]);
            ctx.moveTo(0, y);
            ctx.lineTo(canvas.value.width, y);
            ctx.stroke();
        };

        const drawUnits = () => {
            const y = (isMobile.value ? 60 : 67) * scale;
            const space = subInUnits * (unitSpace + unitWidth) - unitWidth;
            const startN = isMobile.value ? 0 : 3;
            const start = startN * (unitSpace + unitWidth) - offset;
            ctx.strokeStyle = 'white';
            ctx.lineWidth = 24 * scale;
            ctx.beginPath();
            ctx.setLineDash([unitWidth, space]);
            ctx.moveTo(start, y);
            ctx.lineTo(canvas.value.width, y);
            ctx.stroke();
        };

        const drawSubUnits = () => {
            const y = (isMobile.value ? 67 : 74) * scale;
            ctx.strokeStyle = 'white';
            ctx.lineWidth = 10 * scale;
            ctx.beginPath();
            ctx.setLineDash([unitWidth, unitSpace]);
            ctx.moveTo(-offset, y);
            ctx.lineTo(canvas.value.width, y);
            ctx.stroke();
        };

        const drawArrow = () => {
            const y = (isMobile.value ? 32 : 45) * scale;
            const startN = isMobile.value ? 10 : 3;
            const start = startN * (unitSpace + unitWidth) + unitWidth;
            const h = (isMobile.value ? 40 : 34) * scale;
            ctx.strokeStyle = '#FFA360';
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.setLineDash([]);
            ctx.moveTo(start, y);
            ctx.lineTo(start, y+h);
            ctx.stroke();
        };

        const drawLabels = () => {
            ctx.textAlign = 'center';
            ctx.fillStyle = 'white';
            const size = (isMobile.value ? 14 : 16)*scale;
            ctx.font = `${size}px ObjectSansMedium, Arial, sans-serif`;
            const top = (isMobile.value ? 42 : 42)*scale;

            const widthUnit = subInUnits * (unitSpace + unitWidth);
            const subOffset = isMobile.value ? 0 : 3;
            const offsetStart = subOffset * (unitSpace + unitWidth) - offset;
            const unitOffset = isMobile.value ? 2 : 0;
            const currentOfsettedIndex = (Math.ceil(countUnits - pointerValue.value * countUnits) + unitOffset + countUnits) % countUnits;
            const maxTopOffset = isMobile.value ? 25 : 25;
            const baseDrawedUnits = 6;
            const drawedUnits = Math.max(baseDrawedUnits, Math.min(baseDrawedUnits, countUnits + unitOffset));

            const maxOffset = subInUnits * (unitSpace + unitWidth);
            const unitProgrtess = offset / maxOffset;

            for (let i = 0; i < drawedUnits; i++) {
                const offsetIndex = (currentOfsettedIndex + i - 1 + countUnits) % countUnits;

                let topOffset = 0;
                if (i - 1 === unitOffset) {
                    topOffset = unitProgrtess * maxTopOffset;
                } else if (i === unitOffset) {
                    topOffset = (1 - unitProgrtess) * maxTopOffset;
                }

                const text = props.products[offsetIndex];
                ctx.fillText(text, i * widthUnit + offsetStart, top - topOffset);
            }

        };

        const calcOffset = () => {
            const maxOffset = subInUnits * (unitSpace + unitWidth);
            const offsetReal = (1 - (pointerValue.value * countUnits) % 1) * maxOffset;
            offset = Number.isNaN(offsetReal) ? 0 : offsetReal;
        };


        const draw = () => {
            ctx.clearRect(0, 0, canvas.value.width, canvas.value.height);
            calcOffset();
            drawSubline();
            drawUnits();
            drawSubUnits();
            drawArrow();
            drawLabels();
        };

        const init = () => {
            ctx = canvas.value.getContext('2d');
        };

        const onMove = (e) => {
            let offsetX;
            const { left, width } = canvasRect;
            if (e.type === 'touchmove') {
                offsetX = e.touches[0].clientX - left;
            } else offsetX = e.clientX - left;

            if (!pointerIsDown) return;

            if (typeof e.cancelable !== 'boolean' || e.cancelable) e.preventDefault();
            e.stopPropagation();

            moveDelta = (offsetX - pointerStartValue) / width;

            pointerValue.value = Math.max(moveDelta + pointerValueOld + 2, 0) % 1;
        };

        const onDown = (e) => {
            if (e.target !== canvas.value) {
                pointerIsDown = false;
                return;
            }

            pointerIsDown = true;
            userAction = true;

            if (!isMobile.value) {
                if (typeof e.cancelable !== 'boolean' || e.cancelable) e.preventDefault();
                e.stopPropagation();
            }

            if (animation) animation.pause();

            let offsetX;
            const { left } = canvasRect;
            if (e.type === 'touchstart') {
                offsetX = e.touches[0].clientX - left;
            } else offsetX = e.clientX - left;

            pointerStartValue = offsetX;
            pointerValueOld = pointerValue.value;
        };

        let animation;
        const onUp = () => {
            pointerIsDown = false;

            if (animation) animation.pause();

            let value;

            if (Math.abs(moveDelta) < 1 / countUnits) {
                value = moveDelta > 0 ? Math.ceil(pointerValue.value*countUnits)/countUnits : Math.floor(pointerValue.value*countUnits)/countUnits;
            } else {
                value = Math.round(pointerValue.value*countUnits)/countUnits;
            }

            animation = anime({
                targets: pointerValue,
                value,
                duration: 200,
                easing: 'easeOutSine',
                complete: async () => {
                    await nextTick();
                    userAction = false;
                }
            });

        };

        watch(pointerValue, () => {
            draw();
        });

        onMounted(() => {
            init();
            if (isMobile.value) {
                window.addEventListener('touchmove', onMove, { passive: false });
                window.addEventListener('touchstart', onDown, { passive: false });
                window.addEventListener('touchend', onUp, { passive: true });
                window.addEventListener('touchcancel', onUp, { passive: true });
            } else {
                window.addEventListener('mousemove', onMove, { passive: true });
                window.addEventListener('mousedown', onDown, { passive: false });
                window.addEventListener('mouseup', onUp, { passive: true });
            }
        });

        useResize(() => {
            calcScale();
            updateSize();
            draw();
        }, true);

        onUnmounted(() => {
            if (isMobile.value) {
                window.removeEventListener('touchmove', onMove, { passive: false });
                window.removeEventListener('touchstart', onDown, { passive: false });
                window.removeEventListener('touchend', onUp, { passive: true });
                window.removeEventListener('touchcancel', onUp, { passive: true });
            } else {
                window.removeEventListener('mousemove', onMove, { passive: true });
                window.removeEventListener('mousedown', onDown, { passive: false });
                window.removeEventListener('mouseup', onUp, { passive: true });
            }
        });

        watch(() => props.value, (val) => {
            if (userAction) return;

            const value = 1 - val / countUnits;

            if (value === pointerValue.value) return;

            if (animation) animation.pause();
            animation = anime({
                targets: pointerValue,
                value,
                duration: 200,
                easing: 'easeOutSine',
            });
        });

        watch(pointerValue, (val) => {
            if (!userAction) return;

            const value = (Math.ceil((1 - val - 1 / countUnits / 2 + 1)%1 * countUnits) + countUnits) % countUnits;

            if (value === props.value) return;

            emit('input', value);
        });

        return {
            canvas,
            isMobile,
            pointerValue,
        }
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/mixins';
@import '../../assets/scss/base/functions';

.private-ruler {
    cursor: pointer;
    mask-repeat: no-repeat;
    mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, black 5%, black 70%, rgba(0, 0, 0, 0) 100%);
    mask-mode: alpha;

    @include mobile {
        mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, black 30%, black 70%, rgba(0, 0, 0, 0) 100%);
    }
}
</style>
